type AuthLandingLocation = {
  pathname: string;
  search?: string;
  hash?: string;
};

const parseUrlParams = (value = "") =>
  new URLSearchParams(value.startsWith("?") || value.startsWith("#") ? value.slice(1) : value);

const appendIfPresent = (target: URLSearchParams, key: string, value: string | null) => {
  if (value) target.set(key, value);
};

export const getRecoveryRedirectTarget = ({ pathname, search = "", hash = "" }: AuthLandingLocation) => {
  if (pathname === "/reset-password") return null;
  if (pathname === "/auth") return null;
  if (pathname.startsWith("/auth/")) return null;
  if (pathname.startsWith("/~oauth/native-callback")) return null;

  const hashParams = parseUrlParams(hash);
  const searchParams = parseUrlParams(search);

  const isRecoveryHash = hashParams.get("type") === "recovery";
  const hasPkceCode = !!searchParams.get("code");

  if (isRecoveryHash || hasPkceCode) {
    return `/reset-password${search}${hash}`;
  }

  const error = hashParams.get("error") || searchParams.get("error");
  const errorCode = hashParams.get("error_code") || searchParams.get("error_code");
  const errorDescription = hashParams.get("error_description") || searchParams.get("error_description");

  if (!error && !errorCode && !errorDescription) return null;

  const targetParams = new URLSearchParams();
  appendIfPresent(targetParams, "error", error || errorCode);
  appendIfPresent(targetParams, "error_code", errorCode);
  appendIfPresent(targetParams, "error_description", errorDescription);

  return `/auth?${targetParams.toString()}`;
};
